<template>
    <div class="w-full relative pt-14 md:pt-20 pb-40 md:pb-0">
        <transition name="navigation">
            <div class="w-full bottom-0 z-10 lg:absolute">
                <div class="container relative bg-beige bg-opacity-80">
                    <div
                        class="relative flex flex-wrap items-center justify-between w-full mb-10
                            md:mb-12
                            lg:mb-16 lg:py-6 lg:justify-center
                            xl:mb-20 xl:py-7
                            2xl:mb-24 2xl:py-8"
                        :class="isMobile ? '' : ''"
                        @mouseover="activePoint = null"
                    >
                        <span
                            class="mb-8 top-1/2 transform w-full -translate-y-1/2 text-[12px] block text-center md:mt-0 md:text-[14px] lg:w-auto lg:mb-0 lg:absolute lg:left-6 lg:text-left lg:text-[14px] xl:left-8 2xl:text-[20px] 2xl:left-[46px]">
                            Explore The Exchange by use
                        </span>
                        <button
                            class="uppercase text-[17px] px-[20px] h-8 leading-[30px] rounded-[49px] font-normal mr-[5px] border border-black
                                md:text-[14px] md:mx-3 
                                lg:text-[14px] lg:mx-4 
                                xl:text-[20px] xl:mx-5 xl:h-[34px] xl:leading-[32px] xl:px-8
                                2xl:mx-8"
                            :class="{'bg-[#1A3450] text-white': highlightedCategory === 'office'}"
                            @mouseover="highlightedCategory = 'office'"
                            @mouseleave="highlightedCategory = null"
                        >
                            Office
                        </button>
                        <button
                            class="uppercase text-[17px] px-[20px] h-8 leading-[30px] rounded-[49px] font-normal mr-[5px] border border-black
                                md:text-[14px] md:mx-3 
                                lg:text-[14px] lg:mx-4 
                                xl:text-[20px] xl:mx-5 xl:h-[34px] xl:leading-[32px] xl:px-8
                                2xl:mx-8"
                            :class="{'bg-[#B9562A] text-white': highlightedCategory === 'living'}"
                            @mouseover="highlightedCategory = 'living'"
                            @mouseleave="highlightedCategory = null"
                        >
                            Living
                        </button>
                        <button
                            class="uppercase text-[17px] px-[20px] h-8 leading-[30px] rounded-[49px] font-normal mr-[5px] border border-black
                                md:text-[14px] md:mx-3 
                                lg:text-[14px] lg:mx-4 
                                xl:text-[20px] xl:mx-5 xl:h-[34px] xl:leading-[32px] xl:px-8
                                2xl:mx-8"
                            :class="{'bg-[#EFA736] text-white': highlightedCategory === 'hotel'}"
                            @mouseover="highlightedCategory='hotel'"
                            @mouseleave="highlightedCategory = null"
                        >
                            Hotel
                        </button>
                    </div>
                </div>
            </div>
        </transition>
        <div
            id="videoContainer"
            class="w-full relative"
            :class="{'pb-[56.25%]' : !showVideo || isMobile}"
            @mouseleave="activePoint = null"
        >
            <video
                v-if="showVideo && !isMobile"
                ref="video"
                class="w-full"
                src="https://player.vimeo.com/progressive_redirect/playback/801238267/rendition/1080p/file.mp4?loc=external&signature=2a5f25bddf33ce09871ae94c724cfaf0e1e5d17414c81cf54254b666d9f52dd5"
                playsinline="true"
                webkit-playsinline="true"
                preload="auto"
                muted="muted"
            >
            </video>
            <img
                v-if="!isMobile"
                class="animated-map-image w-full absolute top-0 left-0 h-full block"
                :class="showVideo ? 'opacity-0' : 'opacity-100'"
                :src="`${url}/assets/images/animated-map-bg.jpg`"
            />
            <img
                v-if="isMobile"
                class="w-full absolute top-0 left-0 h-full block"
                :src="`${url}/assets/images/animated-map-bg.jpg`"
            />
            <div v-if="!showVideo || isMobile">
                <transition-group name="highlight">
                    <HotelB5
                        v-if="highlightedCategory === 'hotel' || activePoint === 'Hotel_B5'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <HotelB8
                        v-if="highlightedCategory === 'hotel' || activePoint === 'Hotel_B8'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <OfficeB1
                        v-if="highlightedCategory === 'office' || activePoint === 'Office_B1'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <OfficeB2
                        v-if="highlightedCategory === 'office' || activePoint === 'Office_B2'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <OfficeB10
                        v-if="highlightedCategory === 'office' || activePoint === 'Office_B10'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <ResiB3
                        v-if="highlightedCategory === 'living' || activePoint === 'Resi_B3'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <ResiB4
                        v-if="highlightedCategory === 'living' || activePoint === 'Resi_B4'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <ResiB6
                        v-if="highlightedCategory === 'living' || activePoint === 'Resi_B6'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <ResiB7
                        v-if="highlightedCategory === 'living' || activePoint === 'Resi_B7'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                    <ResiB9
                        v-if="highlightedCategory === 'living' || activePoint === 'Resi_B9'"
                        class="w-full absolute top-0 left-0 h-full block"
                        @close="handleMouseover"
                    />
                </transition-group>
            </div>        
            <transition name="point">
                <div v-if="!showVideo && !isMobile" class="absolute w-full h-full pointer-events-none">
                    <AnimatedMapPoint
                        class="absolute top-[38%] left-[12%]"
                        :active="activePoint === 'Resi_B9'"
                        direction="right"
                        type="living"
                        :item="items.b9"
                        @mouseover="activePoint = 'Resi_B9'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[30%] left-[22%]"
                        :active="activePoint === 'Office_B10'"
                        direction="right"
                        type="office"
                        :item="items.b10"
                        @mouseover="activePoint = 'Office_B10'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[48%] left-[24%]"
                        :active="activePoint === 'Hotel_B8'"
                        direction="right"
                        type="hotel"
                        :item="items.b8"
                        @mouseover="activePoint = 'Hotel_B8'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[23%] left-[34%]"
                        :active="activePoint === 'Office_B1'"
                        direction="left"
                        type="office"
                        :item="items.b1"
                        ref="b1"
                        @mouseover="activePoint = 'Office_B1'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[24%] left-[53%]"
                        :active="activePoint === 'Office_B2'"
                        direction="right"
                        type="office"
                        :item="items.b2"
                        @mouseover="activePoint = 'Office_B2'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[40%] left-[44%]"
                        :active="activePoint === 'Park'"
                        direction="left"
                        type="park"
                        :item="items.park"
                        @mouseover="activePoint = 'Park'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[60%] left-[49%]"
                        :active="activePoint === 'Resi_B7'"
                        direction="right"
                        type="living"
                        :item="items.b7"
                        @mouseover="activePoint = 'Resi_B7'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[49%] left-[64%]"
                        :active="activePoint === 'Resi_B6'"
                        direction="left"
                        type="living"
                        :item="items.b6"
                        @mouseover="activePoint = 'Resi_B6'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[29%] left-[67%]"
                        :active="activePoint === 'Resi_B3'"
                        direction="left"
                        type="living"
                        :item="items.b3"
                        @mouseover="activePoint = 'Resi_B3'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[34%] left-[86%]"
                        :active="activePoint === 'Resi_B4'"
                        direction="left"
                        type="living"
                        :item="items.b4"
                        @mouseover="activePoint = 'Resi_B4'"
                        @close="handleMouseover"
                    />
                    <AnimatedMapPoint
                        class="absolute top-[52%] left-[84%]"
                        :active="activePoint === 'Hotel_B5'"
                        direction="left"
                        type="hotel"
                        :item="items.b5"
                        @mouseover="activePoint = 'Hotel_B5'"
                        @close="handleMouseover"
                    />
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AnimatedMapPoint from "./animated-map-point";
import OfficeB1 from "./layers/OfficeB1.vue"
import OfficeB2 from "./layers/OfficeB2.vue"
import HotelB5 from "./layers/HotelB5.vue"
import HotelB8 from "./layers/HotelB8.vue"
import OfficeB10 from "./layers/OfficeB10.vue"
import ResiB3 from "./layers/ResiB3.vue"
import ResiB4 from "./layers/ResiB4.vue"
import ResiB6 from "./layers/ResiB6.vue"
import ResiB7 from "./layers/ResiB7.vue"
import ResiB9 from "./layers/ResiB9.vue"
export default {
    components: {
        AnimatedMapPoint,
        OfficeB1,
        OfficeB2,
        HotelB5,
        HotelB8,
        OfficeB10,
        ResiB3,
        ResiB4,
        ResiB6,
        ResiB7,
        ResiB9
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        points: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            showVideo: true,
            highlightedCategory: null,
            activePoint: null,
            isMobile: false
        }
    },
    computed: {
        items() {
            return JSON.parse(this.points)
        },
        url() {
            return JSON.parse(this.baseUrl)
        }
    },
    mounted() {
        this.checkMobile()
        if ( !this.isMobile ) {
            gsap.registerPlugin(ScrollTrigger);

            let tlPlan = gsap.timeline({
                scrollTrigger: {
                    trigger: '#videoContainer',
                    start: "top-=50% center",
                    once: true,
                    // markers: true,
                    onEnter: () => {
                        this.$refs.video.play();
                        this.$refs.video.addEventListener('ended', () => { this.showVideo = false; }, false);
                        setTimeout(() => {
                            this.$refs.video.play();
                        }, 100);
                    }
                }
            });

            // gsap.registerPlugin(ScrollTrigger)
            // const tw = this.videoScrub(this.$refs.video, {
            //     scrollTrigger: {
            //         trigger: this.$refs.video,
            //         start: "center center",
            //         end: "+=1400",
            //         markers: false,
            //         scrub: true,
            //         pin: true,
            //         markers: false,
            //         onLeave: (self) => {
            //             let start = self.start;
            //             self.scroll(self.start);
                        
            //             self.disable()
            //             self.animation.progress(1);
            //             ScrollTrigger.refresh();
            //             window.scrollTo(0, start);
            //             this.showVideo = false
            //         }
            //     }
            // })
            
            // setTimeout(() => {
                
            //         tw.scrollTrigger.refresh()
                

            //     // gsap.to('#videoContainer', {
            //     //     scrollTrigger: {
            //     //         trigger: '#videoContainer',
            //     //         start: "top top",
            //     //         end: "+=1400",
            //     //         markers: false,
            //     //         scrub: true,
            //     //         pin: true,
            //     //         markers: true,
            //     //         onLeave: (self) => {
            //     //             let start = self.start;
            //     //             self.scroll(self.start);
                            
            //     //             self.disable()
            //     //             self.animation.progress(1);
            //     //             ScrollTrigger.refresh();
            //     //             window.scrollTo(0, start);
            //     //         }
            //     //     }
            //     // })
            // }, 1500)
        }
        window.addEventListener('resize', this.checkMobile)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile)
    },
    methods: {
        handleMouseover(e) {
            if(e.fromElement.classList.contains('popover') && (e.toElement.tagName.toLowerCase() !== 'path' || e.ToElement.tagName.toLowerCase() === 'polygon')) {
                this.activePoint = null
            }
            if((e.fromElement.tagName.toLowerCase() === 'path' || e.fromElement.tagName.toLowerCase() === 'polygon') && !e.toElement.classList.contains('popover')) {
                this.activePoint = null
            }
        },
        checkMobile() {
            this.isMobile = window.innerWidth < 1023;
        },
        videoScrub(video, vars) {
            video = gsap.utils.toArray(video)[0]; // in case selector text is fed in.
            let once = (el, event, fn) => {
                    let onceFn = function () {
                        el.removeEventListener(event, onceFn);
                        fn.apply(this, arguments);
                    };
                    el.addEventListener(event, onceFn);
                    return onceFn;
                },
                prepFunc = () => { video.play(); video.pause(); },
                prep = () => once(document.documentElement, "touchstart", prepFunc),
                src = video.currentSrc || video.src,
                tween = gsap.fromTo(video, {currentTime: 0}, {paused: true, immediateRender: false, currentTime: video.duration || 1, ease: "none", ...vars}),
                resetTime = () => (tween.vars.currentTime = video.duration || 1) && tween.invalidate();
            prep();
            video.readyState ? resetTime() : once(video, "loadedmetadata", resetTime);

            return tween;
        },
    }
}
</script>